import { MultiInputStreamVisitor } from './multi-input-stream.visitor';
import { JoinPlainObject } from '../plainObjects/join.plainObject';
import { FuzzyComparePlainObject } from '../plainObjects/fuzzyCompare.plainObject';

/* eslint-disable @typescript-eslint/no-explicit-any */
export class JoinVisitor extends MultiInputStreamVisitor {
    protected get _transformation(): JoinPlainObject {
        return this.transformation as JoinPlainObject;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public visitBasicFunction(context: any) {
        const condition = new FuzzyComparePlainObject();
        const expressions = context.expression();
        const fuzzyMatchTag = this._getText(context.basicName());
        if (fuzzyMatchTag === 'fuzzyCompare') {
            condition.leftExpression = expressions[0] ? this._getText(expressions[0]) : '';
            condition.rightExpression = expressions[1] ? this._getText(expressions[1]) : '';
            condition.overrideSimilarityThreshold = expressions[2] ? parseFloat(this._getText(expressions[2])) : 0;
            this._transformation.fuzzyCompareExpressions.push(condition);
        } else {
            this.visitChildren(context);
        }
    }

    public visitExpression(expression: any): void {
        if (expression) {
            if (this._transformation.joinType === 'cross') {
                if (expression[0]) {
                    this._transformation.crossExpression = this._getText(expression[0]);
                }
                if (expression[1]) {
                    this.visit(expression[1]);
                }
            } else {
                this.visit(expression);
            }
        }
    }

    public visitConfiguration(context: any): void {
        const configName: string = this._getText(context.configName());
        if (configName === 'joinType') {
            const joinType = this._getText(context.expression());
            this._transformation.joinType = joinType.substring(1, joinType.length - 1).toLowerCase();
        } else if (configName === 'matchType') {
            const matchType = this._getText(context.expression());
            this._transformation.matchType = matchType.substring(1, matchType.length - 1).toLowerCase();
        } else if (configName === 'ignoreSpaces') {
            const ignoreSpaces = this._getText(context.expression());
            this._transformation.ignoreSpaces = ignoreSpaces === 'true';
        }
        super.visitConfiguration(context);
    }
}
